type IconName =
  | 'alert'
  | 'book'
  | 'bookOpen'
  | 'check'
  | 'clipboard'
  | 'database'
  | 'expand'
  | 'external'
  | 'file'
  | 'flag'
  | 'folder'
  | 'image'
  | 'link'
  | 'list'
  | 'network'
  | 'refresh'
  | 'settings'
  | 'shield'
  | 'trash'
  | 'upload'
  | 'user'

const iconPaths: Record<IconName, string[]> = {
  alert: ['M12 9v4', 'M12 17h.01', 'M10.3 3.7 2.4 17.4A2 2 0 0 0 4.1 20h15.8a2 2 0 0 0 1.7-2.6L13.7 3.7a2 2 0 0 0-3.4 0Z'],
  book: ['M4 19.5A2.5 2.5 0 0 1 6.5 17H20', 'M4 4v15.5', 'M20 22V4H6.5A2.5 2.5 0 0 0 4 6.5v13'],
  bookOpen: ['M2 5a3 3 0 0 1 3-3h6v18H5a3 3 0 0 0-3 3Z', 'M22 5a3 3 0 0 0-3-3h-6v18h6a3 3 0 0 1 3 3Z', 'M11 2h2v18h-2'],
  check: ['M20 6 9 17l-5-5'],
  clipboard: ['M9 5h6', 'M9 3h6v4H9z', 'M7 5H5v16h14V5h-2', 'M8 12h8', 'M8 16h5'],
  database: ['M4 6c0 1.7 3.6 3 8 3s8-1.3 8-3-3.6-3-8-3-8 1.3-8 3Z', 'M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6', 'M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6'],
  expand: ['M8 3H3v5', 'M16 3h5v5', 'M8 21H3v-5', 'M16 21h5v-5', 'm3 8 6-6', 'm21 8-6-6', 'm3 16 6 6', 'm21 16-6 6'],
  external: ['M14 3h7v7', 'M10 14 21 3', 'M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5'],
  file: ['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z', 'M14 2v6h6', 'M8 13h8', 'M8 17h6'],
  flag: ['M5 22V4', 'M5 4h10l-1 4 1 4H5'],
  folder: ['M3 6h7l2 2h9v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z'],
  image: ['M3 5h18v14H3z', 'm3 16 5-5 4 4 3-3 6 6', 'M15 9h.01'],
  link: ['M10 13a5 5 0 0 0 7.1.1l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1', 'M14 11a5 5 0 0 0-7.1-.1l-2 2A5 5 0 0 0 12 20l1.1-1.1'],
  list: ['M8 6h13', 'M8 12h13', 'M8 18h13', 'M3 6h.01', 'M3 12h.01', 'M3 18h.01'],
  network: ['M12 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', 'M5 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', 'M19 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', 'M12 23a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', 'm11 5-5 8', 'm13 5 5 8', 'm6 17 5 4', 'm18 17-5 4'],
  refresh: ['M20 6v5h-5', 'M4 18v-5h5', 'M18 9a7 7 0 0 0-12-2L4 11', 'M6 15a7 7 0 0 0 12 2l2-4'],
  settings: ['M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z', 'M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2 3.4-.1-.1a1.7 1.7 0 0 0-1.9-.3l-.5.2a1.7 1.7 0 0 0-1 1.5V22h-4v-.3a1.7 1.7 0 0 0-1-1.5l-.5-.2a1.7 1.7 0 0 0-1.9.3l-.1.1-2-3.4.1-.1A1.7 1.7 0 0 0 5.2 15l-.4-.5a1.7 1.7 0 0 0-1.6-.7H3V10h.2a1.7 1.7 0 0 0 1.6-.7l.4-.5a1.7 1.7 0 0 0-.3-1.9l-.1-.1 2-3.4.1.1a1.7 1.7 0 0 0 1.9.3l.5-.2a1.7 1.7 0 0 0 1-1.5V2h4v.3a1.7 1.7 0 0 0 1 1.5l.5.2a1.7 1.7 0 0 0 1.9-.3l.1-.1 2 3.4-.1.1a1.7 1.7 0 0 0-.3 1.9l.4.5a1.7 1.7 0 0 0 1.6.7h.2v3.8h-.2a1.7 1.7 0 0 0-1.6.7Z'],
  shield: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z', 'm9 12 2 2 4-4'],
  trash: ['M3 6h18', 'M8 6V4h8v2', 'm19 6-1 15H6L5 6', 'M10 11v6', 'M14 11v6'],
  upload: ['M12 16V4', 'm7 9 5-5 5 5', 'M5 20h14'],
  user: ['M20 21a8 8 0 0 0-16 0', 'M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z'],
}

export function Icon({ name, size = 18 }: { name: IconName; size?: number }) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
    >
      {iconPaths[name].map((path) => (
        <path
          d={path}
          key={path}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      ))}
    </svg>
  )
}
